import React, {  } from 'react';
import styles from '../Wyszukiwarka.module.css';
import { useZamowienia } from 'hooks/useZamowienia';


export default function Isbn({isbn, setIsbn} ){
    const { globalSearch } = useZamowienia();
    const handleSubmit = (event) => {
    event.preventDefault(); // Blokuje przeładowanie strony po wciśnięciu Enter
    globalSearch();
  };

  return(
      <form onSubmit={handleSubmit} className={styles.colData}>

      <label className={styles.labelData}> ISBN </label>
      <input className={styles.inputData} style={{width:"140px"}} type="text"
      value={isbn}
      onChange={(event) => {
         const re = /^[a-zA-Z0-9_+\sąćęłńóśźżĄĘŁŃÓŚŹŻŚĆŹ.-/-ŠšŽžČčĐđ,!:]+$/;
        setIsbn(event.target.value);
      }}></input>
    </form>
  );
}

//9788376218007